import axios from 'axios';
import dayjs from '@/helpers/dayjstz';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    selected: null,
    items: [],
    areItemsFetched: false
});

export const getters = {
    selected: state => state.selected,
    items: state => state.items,
    areItemsFetched: state => state.areItemsFetched
};

export const mutations = {
    SET_ITEMS(state, items) {
        state.items = cloneDeep(items);
    },

    ADD_ITEM(state, item) {
        state.items.push(cloneDeep(item));
    },

    UPDATE_ITEM(state, item) {
        const index = state.items.findIndex(i => i.id === item.id);

        state.items.splice(index, 1, cloneDeep(item));
    },

    DELETE_ITEM(state, id) {
        const index = state.items.findIndex(item => item.id === id);

        state.items.splice(index, 1);
    },

    SET_ARE_ITEMS_FETCHED(state, areItemsFetched) {
        state.areItemsFetched = areItemsFetched;
    },

    SET_SELECTED(state, user) {
        state.selected = user;
    }
};

export const actions = {
    async index({ commit, getters: { items, areItemsFetched } }, forced = false) {
        if (!forced && areItemsFetched) {
            return items;
        }

        const teams = await axios.$get('/v1/teams');

        commit('SET_ITEMS', teams);
        commit('SET_ARE_ITEMS_FETCHED', true);

        return teams;
    },

    async store({ commit }, { name, accountIds }) {
        const team = await axios.$post('/v1/teams', {
            name,
            account_ids: accountIds
        });

        commit('ADD_ITEM', team);

        return team;
    },

    async update({ commit }, { name, id, accountIds }) {
        const team = await axios.$patch(`/v1/teams/${id}`, {
            name,
            account_ids: accountIds
        });

        commit('UPDATE_ITEM', team);

        return team;
    },

    async destroy({ commit }, id) {
        await axios.$delete(`/v1/teams/${id}`);

        commit('DELETE_ITEM', id);
    },

    getStats(vuexContext, { teamMemberIds = [], contextId, contextType, time: [from, to] }) {
        const params = {
            account_ids: teamMemberIds,
            'range[from]': dayjs.unix(from).toISOString(),
            'range[to]': dayjs.unix(to).toISOString()
        };

        if (contextId) {
            params.context_id = contextId;
        }

        if (contextType) {
            params.context_type = contextType;
        }

        return axios.$get('/v1/account_events', {
            params
        });
    },

    getLabelsStats(vuexContext, { teamMemberIds = [], contextId, contextType, time: [from, to] }) {
        const params = {
            account_ids: teamMemberIds,
            'range[from]': dayjs.unix(from).toISOString(),
            'range[to]': dayjs.unix(to).toISOString()
        };

        if (contextId) {
            params.context_id = contextId;
        }

        if (contextType) {
            params.context_type = contextType;
        }

        return axios.$get('/v1/account_events/labels', {
            params
        });
    },

    downloadCSV() {
        return axios.$get('/example-csv');
    },

    setSelected({ commit }, team) {
        commit('SET_SELECTED', team);
    }
};
